import React, { useContext, useEffect, useState } from "react";
import UserContext from "../../contexts/UserContext";
import Utils from "../../Utils";
import _ from "lodash";

const PhCertification = (props) => {
  const { userData } = useContext(UserContext);
  const [certified, setCertified] = useState(false);


  return (
    <>
    {/* If Hotel Representative is notcertified */}
    {certified == false && (
        <>
        <div class="dashboard-section">
            <div class="section-title">
                <i class="fas fa-certificate"></i>
                Certification Status
            </div>
            <div class="flex items-center space-x-6">
                <div class="certification-badge not-certified">
                    <i class="fas fa-certificate"></i>
                </div>
                <div>
                    <p class="text-sm text-gray-600">Certification Status</p>
                    <p class="text-lg font-bold text-gray-800 mb-2">No Certification</p>
                    <a href="photographer-get-certified" class="btn px-4 py-2 rounded text-white font-semibold text-sm flex items-center space-x-2 hover:opacity-90">
                        <i class="fas fa-certificate"></i>
                        <span>Get Certified</span>
                    </a>
                </div>
            </div>
        </div>
        </>
    )}
    {/* If Hotel Representative is certified */}
    {certified == true && (
        <>
        <div class="dashboard-section">
            <div class="section-title">
                <i class="fas fa-certificate"></i>
                Certification Status
            </div>
            <div class="flex items-center space-x-6">
                <div class="certification-badge">
                    <i class="fas fa-certificate"></i>
                </div>
                <div>
                    <p class="text-sm text-gray-600">Certification Status</p>
                    <p class="text-lg font-bold text-gray-800">Active &amp; Valid</p>
                    <p class="text-sm text-red-600 mt-1"><i class="fas fa-calendar"></i> Expires: 30-Jun-2026</p>
                </div>
            </div>
        </div>
        </>
    )}
    </>
  );
};

export default PhCertification;
